<template>
  <div class="pa-4" :style="{padding:isMobile.isMobile?'0px 15px !important':''}">
    <v-card>
      <v-toolbar color="success" v-if="!isMobile.isMobile">
        <span class="white--text text-subtitle-1">编译申请</span>
      </v-toolbar>
      <div class="pa-4 textWrap" >
        <v-progress-circular
          v-if="loading"
          indeterminate
          style="position: absolute; left: 0; right: 0; top: 0; bottom: 0; margin: auto"
          color="rgb(76, 175, 80)"
        ></v-progress-circular>

        <v-data-table
          :headers="headers"
          :items="applyList"
          :sort-by="['currentSort', 'currentSortOrder']"
          :items-per-page="pagination.perPage"
          :page="pagination.currentPage"
          :sort-desc="[false, true]"
          multi-sort
          hide-default-footer
          no-data-text="暂无申请"
          class="paginated-table table-striped table-hover"
        >
          <!-- <template v-slot:top>
            <v-row justify="space-between">
              <v-col class="d-flex" cols="6" sm="2">
                <v-select v-model="pagination.perPage" :items="pagination.perPageOptions" class="compilePageSize" label="每页显示"></v-select>
              </v-col>
              <v-col class="d-flex" cols="6" sm="2">
                <v-text-field v-model="queryParams.name" label="查找" type="search" class="mb-3 valueFilter" clearable
                  style="width: 200px"></v-text-field>
              </v-col>
            </v-row>
          </template>-->
          <template #top>
            <v-toolbar flat height="80" class="toolbar">
              <v-text-field
                v-model="queryParams.name"
                append-icon="mdi-magnify"
                label="请输入名称"
                single-line
                hide-details
                @keydown="keydownSearch"
                class="valueFilter"
              ></v-text-field>
              <md-tooltip md-direction="top">按回车以检索</md-tooltip>

              <!-- <v-spacer></v-spacer>
                <v-btn
                  height="35"
                  :ripple="false"
                  small
                  elevation="0"
                  class="font-weight-normal text-capitalize btn-primary bg-gradient-success py-3 px-6 ms-3"
                  >新增</v-btn
              >-->
            </v-toolbar>
          </template>
          <template v-slot:item.version="{ item }">{{ isV(item.version) }}{{ item.version}}</template>
          <template v-slot:item.apply_status="{ item }">{{ item.apply_status | statusMap }}</template>
          <template
            v-slot:item.updated_at="{ item }"
          >{{ new Date(item.updated_at).toLocaleString() }}</template>
        </v-data-table>
      </div>

      <!-- <div class="d-flex justify-space-between align-center mt-4">
        <p class="card-category">{{ from + 1 }} 到 {{ to }} ，共 {{ total }}</p>
        <pagination class="pagination-no-border pagination-success" v-model="pagination.currentPage"
          :per-page="pagination.perPage" :total="pagination.total"> </pagination>
        <v-btn color="success" small >新增</v-btn>
      </div>-->

      <v-card-actions class="vCard-actions d-flex justify-space-between ma-3">
        <div class="md-layout md-gutter">
          <div
            class="md-layout-item md-xlarge-size-90 md-large-size-90 md-medium-size-80 md-small-size-80 md-xsmall-size-80"
          >
            <p class="card-category">{{ from + 1 }} 到 {{ to }} ，共 {{ total }}</p>
          </div>
          <!-- <div
            class="md-layout-item md-xlarge-size-10 md-large-size-10 md-medium-size-20 md-small-size-20 md-xsmall-size-20"
          >
            <v-btn color="success" small>新增</v-btn>
          </div> -->
          <div
            class="md-layout-item md-xlarge-size-100 md-layout md-gutter md-alignment-center-center md-large-size-100 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
          >
            <pagination
              class="pagination-no-border pagination-success"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
            ></pagination>
          </div>
        </div>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { Pagination } from '@/components';
import Swal from 'sweetalert2';
import { listSimulation, updateSimulation } from '@/api/simulation';
import { mapGetters } from 'vuex';
export default {
  name: 'applyComplie',
  filters: {
    statusMap(status) {
      const map = {
        0: '待审核',
        1: '已通过',
        2: '已拒绝',
        3: '已撤回',
      };
      return map[status];
    },
  },
  components: { Pagination },
  computed: {
    ...mapGetters(['isMobile']),
    from() {
      return (this.pagination.currentPage - 1) * this.pagination.perPage;
    },
    to() {
      return this.pagination.currentPage * this.pagination.perPage;
    },
    total() {
      return this.pagination.total;
    },
  },
  watch: {
    from() {
      this.getList();
    },
    'queryParams.name'() {
      this.getList();
    },
  },
  data: () => ({
    loading: false,
    selectedItem: 1,
    applyList: [],
    headers: [
      { text: '项目名称', align: 'center', value: 'name' },
      { text: '版本号', align: 'center', value: 'version' },
      { text: '平台类型', align: 'center', value: 'platform' },
      { text: '审核状态', align: 'center', value: 'apply_status' },
      { text: '审核时间', align: 'center', value: 'updated_at' },
    ],
    currentSort: 'name',
    currentSortOrder: 'asc',
    pagination: {
      perPage: 5,
      currentPage: 1,
      perPageOptions: [5, 10, 15, 25],
      total: 0,
    },
    queryParams: {},
    taskModeMap: {
      study: '学习',
      train: '练习',
      exam: '考核',
    },
  }),
  mounted() {
    this.getList();
  },
  methods: {
    isV(data) {
      let v = '';
      if (data.indexOf('v') !== -1) {
        return '';
      } else {
        v = 'v';
      }

      if (data.indexOf('V') !== -1) {
        return '';
      } else {
        v = 'V';
      }
      return v;
    },
    keydownSearch(e) {
      // 点击Enter
      if (e.keyCode === 13) {
        this.pagination.currentPage = 1;
        this.getList();
      }
    },
    getList() {
      this.loading = true;

      const queryParams = Object.assign(
        {},
        {
          ...this.pagination,
          ...this.queryParams,
        }
      );

      listSimulation(queryParams).then(res => {
        this.loading = false;
        this.applyList = res.data.rows;
        this.pagination.total = res.data.total;
      });
    },
    async handleStatus(status, item) {
      const map = {
        1: '通过',
        2: '拒绝',
      };
      let result = await Swal.fire({
        title: '提示',
        text: `确认${map[status]} 的编译申请？`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-success btn-fill',
        cancelButtonClass: 'md-button md-danger btn-fill',
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        buttonsStyling: false,
      });

      if (result.value) {
        const data = Object.assign(item, { apply_status: status });
        updateSimulation(data).then(res => {
          this.$store.dispatch('global/showSuccessMsg', '操作成功');
          this.getList();
        });
      }
    },
    async handleDelete(item) {
      let result = await Swal.fire({
        title: '删除信息',
        text: `${item.name} 被删除后将无法恢复，请确认！`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-success btn-fill',
        cancelButtonClass: 'md-button md-danger btn-fill',
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        buttonsStyling: false,
      });

      if (result.value) {
        this.$store.dispatch('task/removeTask', item);
      }
    },
  },
};
</script>

<style scoped>
.textWrap {
  position: relative;
}
.white--text {
  margin-left: 25px;
}
.pa-4 {
  padding-top: 0px !important;
}
.toolbar {
  margin-top: 7px;
  padding: 0;
}
/deep/ .toolbar .v-toolbar__content {
  padding: 0px;
}
</style>
